import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import InputMask from 'react-input-mask';
import Select from 'react-select';

class EmployersEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.employer_id,
      name: this.props.employer_data.name,
      social_name: this.props.employer_data.social_name,
      short_name: this.props.employer_data.short_name,
      address: this.props.employer_data.address,
      number: this.props.employer_data.number,
      complement: this.props.employer_data.complement,
      neighborhood: this.props.employer_data.neighborhood,
      cep: this.props.employer_data.cep,
      city: this.props.employer_data.city,
      province: this.props.employer_data.province,
      country_id: this.props.employer_data.country_id,
      phone: this.props.employer_data.phone,
      phone_2: this.props.employer_data.phone_2,
      email: this.props.employer_data.email,
      email_2: this.props.employer_data.email_2,
      cnpj: this.props.employer_data.cnpj,
      contact_name: this.props.employer_data.contact_name,
      observations: this.props.employer_data.observations,
      list_countries: [],
    };

    this.editar = this.editar.bind(this);
  }
  
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined') {
      this.setState({
        id: newProps.employer_id,
        name: newProps.employer_data.name,
        social_name: newProps.employer_data.social_name,
        short_name: newProps.employer_data.short_name,
        address: newProps.employer_data.address,
        number: newProps.employer_data.number,
        complement: newProps.employer_data.complement,
        neighborhood: newProps.employer_data.neighborhood,
        cep: newProps.employer_data.cep,
        city: newProps.employer_data.city,
        province: newProps.employer_data.province,
        country_id: newProps.employer_data.country_id,
        phone: newProps.employer_data.phone,
        phone_2: newProps.employer_data.phone_2,
        email: newProps.employer_data.email,
        email_2: newProps.employer_data.email_2,
        cnpj: newProps.employer_data.cnpj,
        contact_name: newProps.employer_data.contact_name,
        observations: newProps.employer_data.observations,
      });
    }
    if(Array.isArray(newProps.list_countries)) {
      this.setState({list_countries: newProps.list_countries});
    }
  }
  
  // Fetch salvando a edição
  editar(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      social_name: this.state.social_name,
      short_name: this.state.short_name,
      address: this.state.address,
      number: this.state.number,
      complement: this.state.complement,
      neighborhood: this.state.neighborhood,
      cep: this.state.cep,
      city: this.state.city,
      province: this.state.province,
      country_id: this.state.country_id,
      phone: this.state.phone,
      phone_2: this.state.phone_2,
      email: this.state.email,
      email_2: this.state.email_2,
      cnpj: this.state.cnpj,
      contact_name: this.state.contact_name,
      observations: this.state.observations,
      deprecated: '0',
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/empregador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title pull-left">Editar empregador</h3>
  <div className="clearfix"></div>
  <hr/>
  <form onSubmit={this.editar}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome fantasia:</label>
          <input type="text" name="name" className="form-control" placeholder="Nome do Empregador" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Razão social:</label>
          <input type="text" name="social_name" className="form-control" placeholder="Razão Social do Empregador" value={this.state.social_name} onChange={this.handleChange.bind(this, 'social_name')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Nome Curto:</label>
          <input maxLength={5} type="text" name="short_name" className="form-control" placeholder="Nome Curto (05 caracteres)" value={this.state.short_name} onChange={this.handleChange.bind(this, 'short_name')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Endereço:</label>
          <input type="text" name="address" className="form-control" placeholder="Endereço do Empregador" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Número:</label>
          <input type="text" name="number" className="form-control" placeholder="Número do endereço" value={this.state.number} onChange={this.handleChange.bind(this, 'number')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Complemento:</label>
          <input type="text" name="complement" className="form-control" placeholder="Complemento do endereço" value={this.state.complement} onChange={this.handleChange.bind(this, 'complement')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>CEP:</label>
          <InputMask value={this.state.cep}  maskChar={null} name="cep" mask="99.999-999" className="form-control" onChange={this.handleChange.bind(this, 'cep')} placeholder="CEP do Empregador" />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Bairro:</label>
          <input type="text" name="neighborhood" className="form-control" placeholder="Bairro do Empregador" value={this.state.neighborhood} onChange={this.handleChange.bind(this, 'neighborhood')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Cidade:</label>
          <input type="text" name="city" className="form-control" placeholder="Cidade do Empregador" value={this.state.city} onChange={this.handleChange.bind(this, 'city')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>País:</label>
          <Select
            className="form-field-name"
            name="country_id"
            value={this.state.country_id}
            searchable={true}
            placeholder={'Selecionar País'}
            onChange={this.handleSelectChange.bind(this, 'country_id')}
            options={this.state.list_countries}
          />    
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Estado:</label>
          <Select
            className="form-field-name"
            name="province"
            value={this.state.province}
            searchable={true}
            placeholder={'Estado do Empregador'}
            onChange={this.handleSelectChange.bind(this, 'province')}
            options={[
              {value: "AC", label: "Acre"},
              {value: "AL", label: "Alagoas"},
              {value: "AM", label: "Amazonas"},
              {value: "AP", label: "Amapá"},
              {value: "BA", label: "Bahia"},
              {value: "CE", label: "Ceará"},
              {value: "DF", label: "Distrito Federal"},
              {value: "ES", label: "Espírito Santo"},
              {value: "GO", label: "Goiás"},
              {value: "MA", label: "Maranhão"},
              {value: "MT", label: "Mato Grosso"},
              {value: "MS", label: "Mato Grosso do Sul"},
              {value: "MG", label: "Minas Gerais"},
              {value: "PA", label: "Pará"},
              {value: "PB", label: "Paraíba"},
              {value: "PR", label: "Paraná"},
              {value: "PE", label: "Pernambucano"},
              {value: "PI", label: "Piauí"},
              {value: "RJ", label: "Rio de Janeiro"},
              {value: "RN", label: "Rio Grande do Norte"},
              {value: "RO", label: "Rondônia"},
              {value: "RS", label: "Rio Grande do Sul"},
              {value: "RR", label: "Roraima"},
              {value: "SC", label: "Santa Catarina"},
              {value: "SE", label: "Sergipe"},
              {value: "SP", label: "São Paulo"},
              {value: "TO", label: "Tocantins"},
            ]}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Telefone:</label>
          <InputMask value={this.state.phone}  maskChar={null} name="phone" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone')} placeholder="Telefone do Empregador" />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Telefone 2:</label>
          <InputMask value={this.state.phone_2}  maskChar={null} name="phone_2" mask="(99) 9999-99999" className="form-control" onChange={this.handleChange.bind(this, 'phone_2')} placeholder="Telefone 2 do Empregador" />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>E-mail:</label>
          <input type="text" name="email" className="form-control" placeholder="E-mail do Empregador" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>E-mail 2:</label>
          <input type="text" name="email_2" className="form-control" placeholder="E-mail 2 do Empregador" value={this.state.email_2} onChange={this.handleChange.bind(this, 'email_2')} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Funcionário de contato:</label>
          <input type="text" name="contact_name" className="form-control" placeholder="Funcionário de Contato do Empregador" value={this.state.contact_name} onChange={this.handleChange.bind(this, 'contact_name')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>CNPJ:</label>
          <InputMask value={this.state.cnpj}  maskChar={null} name="cnpj" mask="99.999.999/9999-99" className="form-control" onChange={this.handleChange.bind(this, 'cnpj')} placeholder="CNPJ do Empregador" />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Observações:</label>
          <textarea style={{ height: 200 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
        </div>
      </div>
    </div>
    <button type='submit' className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar edição</button>
  </form>
</div>
    );
  }
}

export default EmployersEdit;



// WEBPACK FOOTER //
// ./src/Components/Employers/Elements/EmployersEditTab.js